<script setup>

const props = defineProps({
	class: {
		type: String,
		default: 'size-10',
	},
});
</script>

<template>
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 419 382" :class="props.class">
		<path fill="#E7E7E7" d="m168 328.5 33.5-15L182 271l-16.542 28.5-24.958 43 27.5-14Z"/>
		<path fill="#E9E9E9" d="M62 239h62.5l40.958 60.5L182 271l-13-95-90.5-10.5L62 239Z"/>
		<path fill="#D8D8D8" d="m182 271 43.5-37L266 101.5 169 176l13 95Z"/>
		<path fill="#E9E9E9" d="m257 234 31-84-22-48.5L225.5 234H257Z"/>
		<path fill="#EFEFEF" d="M201.5 313.5 231 381l-5.5-147-43.5 37 19.5 42.5Z"/>
		<path fill="#E2E2E2" d="m231 381 32-55-6-92h-31.5l5.5 147Z"/>
		<path fill="#E4E4E4" d="m288 150 40-18 53 13 11.5-11-35.008-18.5-26.492-14h-65l22 48.5Z"/>
		<path fill="#DBDBDB" d="m392.5 134 8 2.5 17.5-21L384.5 79l-27.008 36.5L392.5 134Z"/>
		<path fill="#ECECEC" d="m335.5 66-4.5 35.5 26.492 14L384.5 79 376 48l-40.5 18Z"/>
		<path fill="#E2E2E2" d="m286.5 6 49 60L376 48l-49-35-40.5-7Z"/>
		<path fill="#DADADA" d="M266 101.5h65l4.5-35.5-49-60L257 36.5l9 65Z"/>
		<path fill="#D1D1D1" d="M257 13v23.5L286.5 6l-28-5-1.5 12Z"/>
		<path fill="#E3E3E3" d="M169 74v102l97-74.5-9-65V13l-88 61Z"/>
		<path fill="#D8D8D8" d="m169 74-90.5 91.5L169 176V74Z"/>
		<path fill="#E5E5E5" d="m30 174.5 48.5-9L169 74 30 174.5Z"/>
		<path fill="#DCDCDC" d="m64 381 76.5-38.5 24.958-43L124.5 239H62L.5 293l9.5 23 29 65h25Z"/>
		<path fill="#EEE" d="M.5 293 62 239l16.5-73.5-48.5 9-27.5 46-2 72.5Z"/>
		<path fill="#D9D9D9" d="m168 381-27.5-38.5L64 381h104Z"/>
		<path fill="#D5D5D5" d="m231 381 75-32-43-23-32 55Z"/>
		<path fill="#E3E3E3" d="M231 381h82l-7-32-75 32ZM195 381h36l-29.5-67.5-33.5 15 27 52.5Z"/>
		<path stroke="#8A8A8A" d="M231 381h82l-7-32m-75 32 75-32m-75 32 32-55m-32 55h-36l-27-52.5m63 52.5-29.5-67.5M231 381l-5.5-147M306 349l-43-23m0 0-6-92m0 0 31-84m-31 84h-31.5m62.5-84 40-18 53 13 11.5-11M288 150l-22-48.5M392.5 134l8 2.5 17.5-21L384.5 79m8 55-35.008-18.5M331 101.5h-65m65 0 4.5-35.5m-4.5 35.5 26.492 14M266 101.5 225.5 234M266 101.5 169 176m97-74.5-9-65m-89 292 33.5-15m-33.5 15-27.5 14m61-29L182 271m43.5-37L182 271m0 0-16.542 28.5M182 271l-13-95m-28.5 166.5L168 381H64m76.5-38.5L64 381m76.5-38.5 24.958-43M64 381H39l-29-65-9.5-23m0 0L62 239M.5 293l2-72.5 27.5-46M62 239h62.5l40.958 60.5M62 239l16.5-73.5m-48.5 9 48.5-9m-48.5 9L169 74m-90.5 91.5L169 74m-90.5 91.5L169 176m0-102v102m0-102 88-61m0 0v23.5m0-23.5 1.5-12 28 5M257 36.5 286.5 6m0 0 49 60m-49-60 40.5 7 49 35m-40.5 18L376 48m8.5 31L376 48m8.5 31-27.008 36.5"/>
	</svg>
</template>
